document.addEventListener('DOMContentLoaded', function () {
  const triggers = document.querySelectorAll('.author-popup-trigger');
  const popups = document.querySelectorAll('.author-popup');

  if (!triggers.length || !popups.length) {
    return;
  }

  // Gehe davon aus, dass die Reihenfolge von Triggern und Popups
  // der Reihenfolge der Komponenten-Instanzen im DOM entspricht.
  triggers.forEach(function (trigger, index) {
    const popup = popups[index];

    if (!popup) {
      return;
    }

    const closeButton = popup.querySelector('.iww-close');

    // Popup initial verstecken (Fallback, zusätzlich zur "hidden"-Klasse im Markup)
    popup.classList.add('hidden');

    function openPopup(event) {
      if (event) {
        event.preventDefault();
      }
      popup.classList.remove('hidden');
    }

    function closePopup(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      popup.classList.add('hidden');
    }

    trigger.addEventListener('click', openPopup);

    if (closeButton) {
      closeButton.addEventListener('click', closePopup);
    }

    // Klick auf das Overlay schließt das Popup, nicht aber Klicks im Inhalt
    popup.addEventListener('click', function (event) {
      // nur schließen, wenn direkt auf das Overlay geklickt wird
      if (event.target === popup) {
        closePopup(event);
      }
    });
  });
});

